
      (function() {
        const DEFAULT_THEME_COLOR = '#d4af37'; // Gold theme
        const DEFAULT_BG_COLOR = '#ffffff';
        const DEFAULT_TEXT_COLOR = '#000000';
        const DEFAULT_BUTTON_COLOR = '#d4af37';
        const API_ENDPOINT = import.meta?.env?.VITE_API_ENDPOINT || 'https://api3.cultaz.com' || 'https://api3.cultaz.com';
        
        // Get domain from current location
        function getDomain() {
          const hostname = window.location.hostname;
          // For localhost or IP, use 'zamfabricspalace.com.ng' as default test domain
          if (hostname === 'localhost' || hostname.startsWith('127.0.0.1')) {
            return 'zamfabricspalace.com.ng';
          }
          return hostname;
        }
        
        // Cache logo to localStorage
        function cacheStoreLogo(logoUrl, storeName) {
          try {
            const cacheData = {
              url: logoUrl,
              storeName: storeName,
              timestamp: Date.now()
            };
            localStorage.setItem('storeLogoCache', JSON.stringify(cacheData));
          } catch (error) {
            console.warn('Failed to cache logo:', error);
          }
        }
        
        // Get cached logo
        function getCachedLogo() {
          try {
            const cached = localStorage.getItem('storeLogoCache');
            if (cached) {
              return JSON.parse(cached);
            }
          } catch (error) {
            console.warn('Failed to retrieve cached logo:', error);
          }
          return null;
        }
        
        // Cache colors to localStorage
        function cacheStoreColors(colors) {
          try {
            const cacheData = {
              ...colors,
              timestamp: Date.now()
            };
            localStorage.setItem('storeColorsCache', JSON.stringify(cacheData));
          } catch (error) {
            console.warn('Failed to cache colors:', error);
          }
        }
        
        // Get cached colors
        function getCachedColors() {
          try {
            const cached = localStorage.getItem('storeColorsCache');
            if (cached) {
              return JSON.parse(cached);
            }
          } catch (error) {
            console.warn('Failed to retrieve cached colors:', error);
          }
          return null;
        }
        
        // Update meta tags and apply theme
        function updateMetadata(data) {
          const store = data.store || data.storeMetadata || {};
          const siteName = store.site_name || store.siteName || 'Zam Fabrics Palace';
          const description = store.description || 'Zam Fabrics Palace — premium fabrics, clothing and textiles.';
          const logo = store.site_logo || store.logo || '/logo.png';
          
          // Theme colors with fallback to cached or default green
          const colors = {
            primary: store.site_color || DEFAULT_THEME_COLOR,
            background: store.site_bg_color || DEFAULT_BG_COLOR,
            text: store.site_text_color || DEFAULT_TEXT_COLOR,
            button: store.site_button_color || DEFAULT_BUTTON_COLOR,
            buttonText: store.site_button_text_color || '#ffffff'
          };
          
          // Update document title
          document.title = siteName;
          
          // Update meta tags
          document.querySelector('meta[name="description"]').content = description;
          document.querySelector('meta[property="og:title"]').content = siteName;
          document.querySelector('meta[property="og:description"]').content = description;
          document.querySelector('meta[name="twitter:title"]').content = siteName;
          document.querySelector('meta[name="twitter:description"]').content = description;
          
          // Update icon elements
          const appleIconEl = document.getElementById('appleIcon');
          const appleStartupEl = document.getElementById('appleStartupImage');
          const faviconEl = document.getElementById('favicon');
          const appTitleEl = document.getElementById('appTitle');
          const themeColorEl = document.getElementById('themeColorMeta');
          
          if (logo) {
            if (appleIconEl) appleIconEl.href = logo;
            if (appleStartupEl) appleStartupEl.href = logo;
            if (faviconEl) faviconEl.href = logo;
            cacheStoreLogo(logo, siteName);
          }
          
          if (appTitleEl) appTitleEl.content = siteName;
          if (themeColorEl) {
            themeColorEl.content = colors.primary;
            document.querySelector('meta[name="msapplication-TileColor"]').content = colors.primary;
          }
          
          // Cache colors
          cacheStoreColors(colors);
          
          // Inject CSS variables for theming
          const root = document.documentElement;
          root.style.setProperty('--color-primary', colors.primary);
          root.style.setProperty('--color-bg', colors.background);
          root.style.setProperty('--color-text', colors.text);
          root.style.setProperty('--color-button', colors.button);
          root.style.setProperty('--color-button-text', colors.buttonText);
          
          // Store metadata in window for React access
          window.__STORE_METADATA__ = store;
          window.__STORE_COLORS__ = colors;
        }
        
        // Fetch store info from API
        async function initializeMetadata() {
          try {
            const domain = getDomain();
            const cachedLogo = getCachedLogo();
            const cachedColors = getCachedColors();
            
            // Try to fetch from API
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);
            
            const response = await fetch(`${API_ENDPOINT}/api/v1/store/store-info?domain=${domain}`, {
              method: 'GET',
              headers: { 'Accept': 'application/json' },
              signal: controller.signal
            });
            
            clearTimeout(timeoutId);
            
            if (response.ok) {
              const data = await response.json();
              if (data.status || data.success) {
                updateMetadata(data);
                return; // Success - no need to use cache
              }
            }
          } catch (error) {
            console.warn('Failed to fetch store metadata:', error);
          }
          
          // Fallback: Use cache or apply default theme
          const cachedColors = getCachedColors();
          const cachedLogo = getCachedLogo();
          
          if (cachedColors) {
            const root = document.documentElement;
            root.style.setProperty('--color-primary', cachedColors.primary);
            root.style.setProperty('--color-bg', cachedColors.background);
            root.style.setProperty('--color-text', cachedColors.text);
            root.style.setProperty('--color-button', cachedColors.button);
            root.style.setProperty('--color-button-text', cachedColors.buttonText);
            window.__STORE_COLORS__ = cachedColors;
          } else {
            // Apply default green theme
            const root = document.documentElement;
            root.style.setProperty('--color-primary', DEFAULT_THEME_COLOR);
            root.style.setProperty('--color-bg', DEFAULT_BG_COLOR);
            root.style.setProperty('--color-text', DEFAULT_TEXT_COLOR);
            root.style.setProperty('--color-button', DEFAULT_BUTTON_COLOR);
            root.style.setProperty('--color-button-text', '#ffffff');
            window.__STORE_COLORS__ = {
              primary: DEFAULT_THEME_COLOR,
              background: DEFAULT_BG_COLOR,
              text: DEFAULT_TEXT_COLOR,
              button: DEFAULT_BUTTON_COLOR,
              buttonText: '#ffffff'
            };
          }
          
          if (cachedLogo) {
            document.getElementById('appleIcon').href = cachedLogo.url;
            document.getElementById('appleStartupImage').href = cachedLogo.url;
            // Keep favicon pointing to /favicon.png unless cache explicitly provides another
            if (cachedLogo.url) document.getElementById('favicon').href = cachedLogo.url;
          }
        }
        
        // Initialize metadata immediately
        initializeMetadata();
      })();
    